// Fechas sin hora ("2026-09-30") deben interpretarse en hora local.
// new Date('2026-09-30') las toma como medianoche UTC, y en México (UTC-6)
// eso se muestra como el día anterior (29 sep).
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export const parseDate = (value) => {
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const m = DATE_ONLY.exec(value.trim());
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  }
  return new Date(value);
};
